import { dateUtil } from "@sdeapps/react-core";

/**
 * Retourne une date formattée uniquement si la valeur est définie
 * @param date Valeur de la date à formatter
 * @param format Format optionnel passé à `dateUtil.format`. Par défaut `dd/MM/yyyy` est utilisé.
 */
export function displayDateIfNotUndefined(
  date: string | Date | undefined,
  format: string = "dd/MM/yyyy"
): string | undefined {
  return date != null && date !== "" ? dateUtil.format(date, format) : undefined;
}
